import { gql } from '@apollo/client';

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation MarkNotificationAsRead($id: ID!) {
    markNotificationAsRead(input: { id: $id }) {
      notification {
        id
        read
        isRead
        isUnread
      }
      errors
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation MarkAllNotificationsAsRead {
    markAllNotificationsAsRead {
      success
      message
    }
  }
`;

export const CREATE_NOTIFICATION = gql`
  mutation CreateNotification($userEmail: String!, $title: String!, $message: String!, $category: String) {
    createNotification(userEmail: $userEmail, title: $title, message: $message, category: $category) {
      id
      title
      message
      category
      read
      isRead
      isUnread
      createdAt
      user {
        id
        email
      }
    }
  }
`;